import { render } from "./ConsolidatedUnitReport.vue?vue&type=template&id=7eecb70a&scoped=true"
import script from "./ConsolidatedUnitReport.vue?vue&type=script&lang=js"
export * from "./ConsolidatedUnitReport.vue?vue&type=script&lang=js"

import "./ConsolidatedUnitReport.vue?vue&type=style&index=0&id=7eecb70a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eecb70a"]])

export default __exports__